import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import PromagContent from "./PromagPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/promag/pumps" component={PromagContent} />
          <Route path="/suppliers/promag">
            <Redirect to="/suppliers/promag/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
